module.exports = __webpack_public_path__ + "img/bank6.0111a273.png";